exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav{background-color:#fff}.nav.root{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.dropdown-menu,.dropdown-menu li{display:block;width:100%}.dropdown-menu li:hover{background-color:#eee}a{border-left:5px solid #a9a9a9}a.active{border-left:5px solid #00aeed}.nav{max-height:80vh;overflow-y:auto}.nav.sub{max-height:0;overflow:hidden}.nav.sub a{font-size:90%;color:#000;text-decoration:underline}.nav.sub.open{transition:max-height .5s;max-height:1000px}.dropdown-toggle{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dropdown-toggle .caret{transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.dropdown-toggle.rotate .caret{-webkit-transform:rotate(180deg);transform:rotate(180deg)}@media (min-width:767px){.nav.root{margin:20px}}@media (max-width:767px){.nav.root{padding-bottom:50px;max-height:100%;overflow-y:auto;box-shadow:none}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/nav-menu/nav-menu.component.css
// module id = 508
// module chunks = 1